import { render, staticRenderFns } from "./XDepartPanel.vue?vue&type=template&id=8308b12c&scoped=true&"
import script from "./XDepartPanel.vue?vue&type=script&lang=js&"
export * from "./XDepartPanel.vue?vue&type=script&lang=js&"
import style0 from "./XDepartPanel.vue?vue&type=style&index=0&id=8308b12c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8308b12c",
  null
  
)

export default component.exports